import * as React from 'react';
import { useState } from 'react';

import { Color, DropdownMenuTriggerTheme } from '../../enums';
import { MenuPositionData } from '../../interfaces';
import { UseState } from '../../types';
import { Icon } from '../icon/icon.component';

import {
  Container,
  DropdownMenuContainer,
  DropdownMenuPosition,
  DropdownMenuPositionLabel,
  DropdownMenuPositionWrapper,
  IconContainer,
  Label,
  TriggerMenuButton
} from './dropdownMenu.styled';
import { DropdownMenuProps } from './dropdownMenu.types';

export const DropdownMenu: React.FC<DropdownMenuProps> = (props: DropdownMenuProps): JSX.Element => {
  const { className, triggerIcon, menuPositions, triggerTheme, label }: DropdownMenuProps = props;
  const [dropdownMenuVisible, setDropdownMenuVisible]: UseState<boolean> = useState<boolean>(false);

  const onBlurAction = (): void => setDropdownMenuVisible(false);

  return (
    <Container className={className} onBlur={onBlurAction} tabIndex={0}>
      <TriggerMenuButton onClick={(): void => setDropdownMenuVisible(!dropdownMenuVisible)}>
        {label && (
          <Label
            $theme={triggerTheme}
            $active={dropdownMenuVisible}
          >
            {label}
          </Label>
        )}
        <IconContainer
          $theme={triggerTheme}
          $active={dropdownMenuVisible}
        >
          <Icon
            name={triggerIcon}
            size={20}
            color={triggerTheme === DropdownMenuTriggerTheme.Black ? Color.White : Color.Black}
          />
        </IconContainer>
      </TriggerMenuButton>
      <DropdownMenuContainer $visible={dropdownMenuVisible}>
        {menuPositions.map((position: MenuPositionData): JSX.Element => (
          <DropdownMenuPositionWrapper onClick={(): void => setDropdownMenuVisible(false)} key={position.label}>
            <DropdownMenuPosition {...position}>
              {position.icon && (
                <Icon
                  name={position.icon}
                  size={20}
                  color={Color.Gray500}
                />
              )}
              <DropdownMenuPositionLabel>{position.label}</DropdownMenuPositionLabel>
            </DropdownMenuPosition>
          </DropdownMenuPositionWrapper>
        ))}
      </DropdownMenuContainer>
    </Container>
  );
};
